import React from 'react'
import { IconProps } from '../types'

export default function CheckCircleIcon({
    className = 'h-[18px] w-[18px]',
    fill = '#34C759',
    ...props
}: IconProps) {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 16.5C4.85775 16.5 1.5 13.1422 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1422 1.5 16.5 4.85775 16.5 9C16.5 13.1422 13.1422 16.5 9 16.5ZM8.11725 10.605L6.0435 8.52975L5.25 9.32325L7.58925 11.664C7.7299 11.8046 7.92063 11.8836 8.1195 11.8836C8.31837 11.8836 8.5091 11.8046 8.64975 11.664L13.1137 7.2015L12.3172 6.405L8.11725 10.605Z"
                fill={fill}
            />
        </svg>
    )
}
